import React, { useEffect, useState } from 'react';
import { Trophy, Flame, Users, Zap } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { API } from './joinConfig';
import { RecruiterBadge } from './RecruiterBadge';

export const useJoinStats = () => {
  const [stats, setStats] = useState(null);
  const [board, setBoard] = useState([]);
  useEffect(() => {
    const load = () => {
      fetch(`${API}/stats`).then(r => r.json()).then(setStats).catch(() => {});
      fetch(`${API}/leaderboard`).then(r => r.json()).then(setBoard).catch(() => {});
    };
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, []);
  return { stats, board };
};

export const StatPills = ({ stats }) => {
  const { t } = useLanguage();
  const items = [
    { icon: Users, val: stats?.total, label: { en: 'members joined', bn: 'জন যোগ দিয়েছেন' }, id: 'total' },
    { icon: Flame, val: stats?.today, label: { en: 'in last 24h', bn: 'গত ২৪ ঘণ্টায়' }, id: 'today' },
    { icon: Zap, val: stats?.youth, label: { en: 'youth (18-30)', bn: 'তরুণ (১৮-৩০)' }, id: 'youth' },
  ];
  return (
    <div className="flex flex-wrap gap-3" data-testid="join-live-stats">
      {items.map(({ icon: Icon, val, label, id }) => (
        <div key={id} className="flex items-center gap-2 rounded-full border border-gray-200 bg-gray-50 px-4 py-2 backdrop-blur-md">
          <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-party-green opacity-75" /><span className="relative inline-flex h-2 w-2 rounded-full bg-party-green" /></span>
          <Icon className="h-4 w-4 text-party-green" />
          <span className="font-join text-lg font-bold text-gray-900" data-testid={`stat-${id}`}>{val ?? '—'}</span>
          <span className="text-xs text-gray-600">{t(label)}</span>
        </div>
      ))}
    </div>
  );
};

export const Leaderboard = ({ board }) => {
  const { t } = useLanguage();
  return (
    <div className="rounded-3xl border border-gray-200 bg-white p-6" data-testid="referral-leaderboard">
      <div className="mb-5 flex items-center gap-2">
        <Trophy className="h-5 w-5 text-amber-600" />
        <h3 className="font-join text-xl font-bold text-gray-900">{t({ en: 'Top Recruiters', bn: 'শীর্ষ রিক্রুটার' })}</h3>
      </div>
      {board.length === 0 ? (
        <p className="text-sm text-gray-500" data-testid="leaderboard-empty">{t({ en: 'No one yet. Share your link and be #1!', bn: 'এখনো কেউ নেই। আপনার লিংক শেয়ার করে #১ হন!' })}</p>
      ) : (
        <ol className="space-y-2">
          {board.map((r, i) => (
            <li key={i} className="flex items-center gap-3 rounded-xl bg-gray-50 px-3 py-2" data-testid={`leaderboard-row-${i}`}>
              <span className={`font-join w-7 text-center text-lg font-black ${i === 0 ? 'text-amber-600' : i < 3 ? 'text-party-green' : 'text-gray-500'}`}>{i + 1}</span>
              <span className="flex min-w-0 flex-1 flex-wrap items-center gap-x-2 text-sm font-semibold text-gray-900">{r.name}<span className="text-xs font-normal text-gray-500">{r.district}</span><RecruiterBadge badge={r.badge} testid={`leaderboard-badge-${i}`} /></span>
              <span className="font-join text-sm font-bold text-party-green">{r.count}</span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
